import React from 'react';

import getTripsMonitoredReport, {
  tripsMonitoredReportUrl,
} from '../../service/tripsMonitoredReportService';
import download from '../../lib/download';
import TripsMonitoredReport from './TripsMonitoredReport';

import { DateRange } from '../../types/dateRange';

export interface DoGetTripsMonitoredReportProps {
  dateRange: DateRange;
  handleFetchError: (errorMessage: string) => void;
  callback: () => void;
}

const doGetTripsMonitoredReport = ({
  dateRange,
  handleFetchError,
  callback,
}: DoGetTripsMonitoredReportProps): void => {
  const dateFormatString = 'MM-DD-YYYY';
  getTripsMonitoredReport(dateRange)
    .then(response => {
      if (response.ok) {
        response
          .text()
          .then(data => {
            const builtDataUrl = `data:text/csv;base64,${btoa(
              new TextEncoder().encode(data).reduce((str, byte) => str + String.fromCharCode(byte), '')
            )}`;
            const filename = `TripsMonitoredReport${dateRange.startDate?.format(
              dateFormatString,
            )}_${dateRange.endDate?.format(dateFormatString)}.csv`;
            download(builtDataUrl, filename);
          })
          .catch(error => {
            handleFetchError('Error processing report response for download.');
            console.error(
              'Error processing report response for download.',
              error,
            );
          });
      } else {
        const { status, statusText } = response;
        handleFetchError(
          `Error response attempting to download trips monitored report. '${status} ${statusText}'`,
        );
        console.error(
          `Error attempting to download trips monitored report at '${tripsMonitoredReportUrl}', w/ body ${JSON.stringify(
            {
              dateStart: dateRange.startDate,
              dateEnd: dateRange.endDate,
            },
          )} '${status} ${statusText}'`,
        );
      }
    })
    .catch(error => {
      handleFetchError('Error attempting to download report.');
      console.error('Error attempting to download report.', error);
    })
    .finally(callback);
};

const TripsMonitoredReportContainer: React.FC = () => {
  return <TripsMonitoredReport onSubmit={doGetTripsMonitoredReport} />;
};

export default TripsMonitoredReportContainer;